import React, {useEffect} from 'react';
import StandardHeader from "../../components/global/StandardHeader";
import {CircularProgress, Divider, Box} from "@mui/material";
import {LeftSidebar} from "../../layout-blueprints";
import ApiKeysTable from "../../modules/apiKeys/components/apiKeysTable";
import {useDispatch, useSelector} from "react-redux";
import {getSettings} from "../../modules/settings/api/actions";

const Index = () => {
  const dispatch = useDispatch();
  const setting = useSelector(state => state.setting.settings.items?.find(setting => setting.name === "apiKeysInternal"))
  const user = JSON.parse(localStorage.getItem('user'));

  const [show, setShow] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [pageLoading, setPageLoading] = React.useState(true);

  const fetchSettings = async () => {
    try{
      setPageLoading(true)
      setShow(false)
      await dispatch(getSettings())
    }catch(e){
      console.log(e)
    }finally {
      setPageLoading(false)
    }
  }

  useEffect(() => {
    if (setting?.value == 1) {
      if (user?.isSuperUser == 1) {
        setShow(true);
        setMessage('')
      } else {
        setShow(false);
        setMessage("You don't have permissions to access this page");
      }
    } else if (setting?.value == 0) {
      setShow(false);
      setMessage("Coming soon...");
    }
  }, [setting, user]);


  useEffect(() => {
    fetchSettings()
  }, [])

  return (
    <LeftSidebar>
      <StandardHeader title="API Keys"/>
      <Divider className="mb-3 mt-3"/>
      {pageLoading ? <CircularProgress
        size={24}
      /> :
        show ? <Box sx={{ width: '100%' }}>
            <ApiKeysTable/>
        </Box> :
          <h1 color={'red'}>{message}</h1>
        }
    </LeftSidebar>
  );
};

export default Index;